import { render, staticRenderFns } from "./ScreenLaudoPersonalizado.vue?vue&type=template&id=784b2e10&lang=true&"
import script from "./ScreenLaudoPersonalizado.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPersonalizado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports